export type RecoveryCallback =
  | { kind: "hash"; accessToken: string; refreshToken: string }
  | { kind: "code"; code: string }
  | { kind: "token_hash"; tokenHash: string }
  | { kind: "error"; message: string }
  | { kind: "missing" };

export const parseRecoveryCallback = (url: string): RecoveryCallback => {
  const parsed = new URL(url);
  const query = parsed.searchParams;
  const hash = new URLSearchParams(parsed.hash.slice(1));
  const error = hash.get("error_description") || query.get("error_description");

  if (error || hash.has("error") || query.has("error")) return { kind: "error", message: "This reset link is invalid or has expired." };

  const tokenHash = query.get("token_hash");
  if (tokenHash && query.get("type") === "recovery") {
    return { kind: "token_hash", tokenHash };
  }
  if (query.has("token_hash") || (query.has("type") && query.get("type") !== "recovery")) {
    return { kind: "error", message: "This reset link is invalid or has expired." };
  }

  const code = query.get("code");
  if (code) return { kind: "code", code };

  const accessToken = hash.get("access_token");
  const refreshToken = hash.get("refresh_token");
  if (hash.get("type") === "recovery" && accessToken && refreshToken) {
    return { kind: "hash", accessToken, refreshToken };
  }

  return { kind: "missing" };
};

export const immediateRecoveryError = (callback: RecoveryCallback): string | null => {
  if (callback.kind === "missing") {
    return "This page was opened without a valid reset link. Please request a new reset email.";
  }
  return null;
};

export const clearRecoveryCredentials = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};